import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';

export interface PreSignPostResponse {
  url: string;
  // formData: { [key: string]: string };
  fileUrl: string;
}

export interface PreSignUrlResponse {
  url: string;
}

@Injectable({
  providedIn: 'root',
})
export class UploadAuthService {
  constructor(private http: HttpClient) {}

  private getPreSignedPostData(fileName: string): Observable<PreSignPostResponse> {
    return this.http.get<PreSignPostResponse>(`/api/v1/pre-sign-post?filename=${fileName}`);
  }

  public async uploadFile(file: File): Promise<string> {
    return await firstValueFrom(this.getPreSignedPostData(file.name))
      .then((response: PreSignPostResponse) => {
        const { url: uploadUrl, fileUrl } = response;

        this.http.put(uploadUrl, file).subscribe({
          error: () => alert('Error uploading file'),
        });

        return fileUrl;
      })
      .catch((error) => {
        alert('Error uploading file');

        return '';
      });
  }

  public getFileUrl(fileUrl: string): Observable<PreSignUrlResponse> {
    return this.http.get<PreSignUrlResponse>(`/api/v1/pre-sign-url/${fileUrl}`);
  }

  public downloadFile(fileUrl: string): void {
    this.getFileUrl(fileUrl).subscribe((response: PreSignUrlResponse) => {
      window.open(response.url, '_blank');
    });
  }
}
